<template>
    <div class="main">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div>
                <!-- <div @click="redirectPreviousUrl" style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
                <p>
                    <a-icon type="double-left" />
                </p> 
                <p>Go Back </p> 
                
            </div> -->

                <h3 style="font-size:28px;line-height:45px">Back Order Campaign</h3>

                <div>
                    <!-- <div style="background:#fbfbfb;padding: 10px;box-shadow: rgb(136 136 136 / 42%) 0px 2px 8px">
                    <a-row>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;" :span="9">
                            <a-col>
                                <div style="display:flex;justify-content: center;">
                                    <img class="img_size" src="../../assets/img/inventory_1.png"/>
                                </div>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                {{showCampaignDate.startDate}}  -  {{showCampaignDate.endDate}}  <span style="color:green">({{showCampaignDate.numberOfDays}})</span>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                StartDate - EndDate
                            </a-col>

                        </a-col>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;text-align:center" :span="7">
                            
                                <img class="img_size" src="../../assets/img/filledoutline.png"/>
                                <div style="padding-top:20px; text-align: -webkit-center;">
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Pending'">
                                        <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p>
                                        <p style="font-size:12px;color:#ffb102;"> {{items.statusLabel}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Live'">
                                        <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p>
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{items.statusLabel}} </p>
                                    </div>
                                

                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === `Completed`">
                                        <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p>
                                        <p style="font-size:12px;color:#41c4fd;"> {{items.statusLabel}} </p>
                                    </div>
                                </div>
                        </a-col>
                        <a-col style="height: 100px;padding: 20px;text-align:center" :span="7">
                            <img class="img_size" src="../../assets/img/cowtribe_logo.png"/>
                            <a-col style="text-align:center;padding-top:10px;font-size:20px;font-weight:bolder">
                                Ksh {{displayTotalAmount}}
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                Total Expected Revenue 
                            </a-col>
                        </a-col>
                    </a-row>
                </div> -->

                    <div style="padding-top:30px;padding-bottom:30px">
                        <div style="display:flex;justify-content: space-between;margin-bottom">

                            <div style="font-size:18px">
                                <p>Campaign Products</p>
                            </div>
                            <div style="display:flex;justify-content: flex-end">

                                <a-select v-if="displayDistCenter" show-search :default-value="displayDistCenter"
                                    option-filter-prop="children" :filter-option="filterOption"
                                    style="margin-right: 10px;width: 260px" @change="handleDistCenters">
                                    <a-select-option v-for="center in distributionCenters" :key="center.id">
                                        {{ center.name }}
                                    </a-select-option>
                                </a-select>
                                <!-- <a-button @click="showPreProduct"  style="width:159px;margin-right: 10px; height:33px; border-raduis:5px; background: #418a49; color:#fff;" icon="plus">
                                    Add Product
                            </a-button> -->
                                <a-dropdown>
                                    <a-menu slot="overlay">
                                        <a-menu-item @click="showAggregateOrder" key="1">Aggregate Orders</a-menu-item>
                                        <a-menu-item @click="showPurchaseOrder" key="2">Purchased Orders</a-menu-item>
                                        <a-menu-item @click="showWaybills" key="3"> Waybill </a-menu-item>
                                    </a-menu>
                                    <a-button
                                        style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                                        icon="select">
                                        Actions
                                        <a-icon type="down" />
                                    </a-button>
                                </a-dropdown>
                            </div>

                        </div>
                        <a-table :columns="columns" :data-source="tableData" :loading="tableLoading"
                            :pagination="pagination" class="tableStyle">
                            <div slot="filterDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px"
                                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                    Reset
                                </a-button>
                            </div>

                            <div slot="filterCategoryDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px"
                                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                    Reset
                                </a-button>
                            </div>

                            <div slot="filterSupplierDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px"
                                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                    Reset
                                </a-button>
                            </div>

                            <div slot="filterManufacturerDropdown"
                                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                style="padding: 8px">
                                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                                <a-button type="primary" icon="search" size="small"
                                    style="width: 90px; margin-right: 8px"
                                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                                    Search
                                </a-button>
                                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                                    Reset
                                </a-button>
                            </div>

                            <span slot="action" slot-scope="data">
                                <a-dropdown>
                                    <a style="color:#98c14b;" class="ant-dropdown-link"
                                        @click="e => e.preventDefault()">
                                        <a-icon style="font-size:25px;" type="ellipsis" />
                                    </a>
                                    <a-menu slot="overlay">
                                        <a-menu-item>
                                            <a @click="showMoreDetailsModal(data)">Edit Campaign?</a>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <a @click="showMoreDetails(data)">View Order?</a>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <a @click="showPriceModal(data)">Generate PO?</a>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <a @click="showPriceModal(data)">Generate Waybill?</a>
                                        </a-menu-item>

                                    </a-menu>
                                </a-dropdown>
                            </span>

                        </a-table>
                    </div>

                </div>
            </div>
            <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
                <div style="display:flex;justify-content: center;">
                    <img class="img_size" src="../../assets/img/inventory_1.png" />
                </div>
                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Add New Product
                </p>
                <div>
                    <a-form-model ref="addProductForm" :model="newProductForm" :rules="rules">
                        <a-row type="flex" justify="center" align="middle">
                            <a-col :span="16">
                                <a-form-model-item label="Select Product" ref="productId" prop="productId">

                                    <a-select show-search placeholder="Choose your product"
                                        option-filter-prop="children" v-model="newProductForm.productId"
                                        :filter-option="filterOption">
                                        <a-select-option v-for="product in availableProducts" :key="product.id"
                                            v-bind:value="product.id">
                                            {{ product.brandName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>

                        </a-row>
                        <a-row type="flex" justify="center" align="middle">
                            <a-col :span="16">
                                <a-form-model-item label="Max Quantity" ref="maxQuantity" prop="maxQuantity">
                                    <a-input class="" v-model="newProductForm.maxQuantity" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="loading" />
                        </div>
                        <div v-show="showAlertMsg" style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-alert message="Product already exist in the Campaign, kindly choose a different product."
                                type="error" />
                        </div>


                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button :loading="modalLoading" @click="addProduct"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Add Product
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

const columns = [

    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: 'productName',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.productName
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        //  width: 150,
    },

    {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        scopedSlots: {
            filterDropdown: 'filterCategoryDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.category
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        //  width: 150,
    },
    {
        title: 'Supplier',
        dataIndex: 'supplier',
        key: 'supplier',
        scopedSlots: {
            filterDropdown: 'filterSupplierDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.supplier
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        //  width: 150,
    },
    {
        title: 'Manufacturer',
        dataIndex: 'manufacturer',
        key: 'manufacturer',
        scopedSlots: {
            filterDropdown: 'filterManufacturerDropdown',
            filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.manufacturer
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        //  width: 150,
    },

    {
        title: "Quantity",
        dataIndex: 'quantity',
        // width: 150,
    },

    {
        title: "Cost Price",
        dataIndex: 'costOfPrice',
        // width: 150,
    },
    {
        title: "Selling Price",
        dataIndex: 'sellingPrice',
        // width: 150,
    },
    {
        title: "Profit",
        dataIndex: 'profit',
        // width: 150,
    },
    //   {
    //     title: "Discount",
    //     dataIndex: 'discount',
    //     // width: 150,
    //   },
    //   {
    //     title: 'Actions',
    //     key: 'action',
    //     dataIndex: 'action',
    //     scopedSlots: { customRender: 'action' }
    //   },
];



export default {
    name: "PreOrdersDetails",
    // props: ['items'],
    data() {
        return {
            items: {},
            columns,
            // columns2,
            tableData: [],
            loading: false,
            tableLoading: false,
            modalLoading: false,
            showAlertMsg: false,
            // tableData2: [],
            availableProducts: [],
            distributionCenterId: '',
            distributionCenters: [],
            defaultValue: '',
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            pagination: {
                pageSize: 20
            },
            searchText: '',
            searchInput: null,
            searchedColumn: '',
            item: {},
            addProductVisible: false,
            newProductForm: {
                productId: "",
                maxQuantity: ""
            },
            rules: {
                maxQuantity: [
                    { required: true, message: 'Please enter quantity', trigger: 'change' },
                    {
                        pattern: new RegExp(/^[0-9]*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
                productId: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],

                margin: [
                    { required: true, message: 'Please enter margin', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],

                discount: [
                    { required: true, message: 'Please enter discount', trigger: 'change' },
                    {
                        pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
                        message: 'Please enter valid number',
                        trigger: 'change'
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters(['getOrder']),

        displayInvoiceId() {
            return this.item.id
        },
        displayDistCenter() {
            return this.defaultValue
        },
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.action.sellingPrice && item.maxQuantity) {
                    return parseFloat(item.action.sellingPrice) * item.maxQuantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        showCampaignDate() {
            const today = moment();
            let startDate = moment(this.items.startDate).format("DD-MMM-YYYY")
            let endDate = moment(this.items.endDate).format("DD-MMM-YYYY")
            let numberOfDays = ""

            // console.log(" statusLabel | ", this.items.statusLabel)
            if (this.items.statusLabel === "Pending") {
                numberOfDays = `${moment(this.items.startDate).diff(today.format(), 'days')} days to start campaign`
            }

            if (this.items.statusLabel === "Completed") {
                numberOfDays = `${moment(today.format()).diff(this.items.endDate, 'days')} days after the end of campaign`
            }

            if (this.items.statusLabel === "Live") {
                numberOfDays = `${moment(this.items.endDate).diff(today.format(), 'days')} days at the end of campaign`
            }

            return {
                startDate: startDate,
                endDate: endDate,
                numberOfDays: numberOfDays
            }
        },

        showOrderStatus() {
            return this.items.statusLabel == "Pending" ? true : false
        }
    },
    methods: {
        ...mapActions(['addPreOrderProduct', 'getPreOrderProducts', 'getClientProducts', 'getAllDistributionCenters', 'getDistributionCenterProducts']),
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
        redirectPreviousUrl() {
            this.$router.back()
        },
        showPreProduct() {
            this.addProductVisible = true;
        },
        handleAddProductCancel() {
            this.addProductVisible = false;
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        showPurchaseOrder() {
            this.$router.push('/purchase-order').catch(() => { });
        },
        showWaybills() {
            this.$router.push('/waybills').catch(() => { });
        },
        showAggregateOrder() {
            this.$router.push('/aggregate-order').catch(() => { });
        },
        handleDistCenters(value) {
            this.distributionCenterId = value
            this.getPreProducts(this.distributionCenterId);
        },

        addProduct() {
            this.$refs.addProductForm.validate(valid => {
                if (valid) {
                    let request_data = {
                        id: this.getOrder.id,
                        data: {
                            productId: this.newProductForm.productId,
                            maxQuantity: this.newProductForm.maxQuantity,
                        }
                    }
                    // console.log("exit product | ", this.checkExistingProduct(this.newProductForm.productId))
                    // console.log("request_data | ", request_data)
                    // console.log("id | ", this.getOrder.id)
                    // console.log("request_data | ", request_data)
                    if (this.checkExistingProduct(this.newProductForm.productId)) {
                        this.showAlertMsg = true;
                    } else {
                        this.showAlertMsg = false;
                        this.modalLoading = true;
                        this.addPreOrderProduct(request_data).then(response => {
                            this.modalLoading = false;
                            if (response.status === 200) {
                                this.addProductVisible = false;
                                this.getPreProducts(this.distributionCenterId);
                                this.showSuccessAlert("New Product Added Successfully")
                                this.$refs.addProductForm.resetFields();
                            } else {
                                console.log('Error | ', response)
                            }
                        }, error => {
                            this.modalLoading = false;
                            console.log('Error | ', error)
                        })
                    }
                } else {
                    return false;
                }
            })
        },
        checkExistingProduct(productId) {
            return this.tableData.some(product => product.key === productId)
        },

        async getPreProducts(id) {
            this.tableLoading = true
            // console.log("distributionCenterId | ", id)
            const distributionCenter = this.distributionCenters.find(center => center.id === id)
            // console.log("distributionCenter | ", distributionCenter)
            let final_request = {
                request_data_1: {
                    page: -1,
                    perPage: -1,
                    searchBy: {},
                    sortBy: {}
                },
                request_data_2: {
                    locationId: distributionCenter.locationId
                },

            }
            const response = await this.getDistributionCenterProducts(final_request)

            let finalAgentInventory = [];

            if (response[0].status !== 200 && response[1].status !== 200) {
                this.showErrorAlert(response.data.messages)
            } else if (response[0].status === 200 && response[1].status === 200) {
                let productsResponse = response[0].data.data
                let inventoryResponse = response[1].data
                // let inventoryWithBal = [];
                let inventoryWithOutBal = [];

                let inventoryIds = inventoryResponse.map(inventory => inventory.productId);

                // for(var product of productsResponse){
                //     for(var inventory of inventoryResponse){
                //         if(product.id === inventory.productId){
                //             // console.log("product | ", product)

                //             let productObj = {
                //                 key: product.id,
                //                 productName: product.brandName,
                //                 category: product.categoryName,
                //                 supplier: product.supplierName,
                //                 manufacturer: product.manufacturerName,
                //                 quantity: inventory.balance,
                //                 costOfPrice: `Ksh ${product.purchasePrice.toLocaleString(undefined,{minimumFractionDigits: 2})}`,
                //                 profit: `Ksh ${product.profit.toLocaleString(undefined,{minimumFractionDigits: 2})}`,
                //                 sellingPrice: `Ksh ${product.sellingPrice.toLocaleString(undefined,{minimumFractionDigits: 2})}`,
                //                 // margin: `${product.margin.toLocaleString(undefined,{minimumFractionDigits: 2})}%`,

                //                 action:product
                //             }
                //             inventoryWithBal.push(productObj)
                //         }
                //     }
                // }

                for (var product2 of productsResponse) {
                    if (!inventoryIds.includes(product2.id)) {
                        // console.log("product | ", product2)
                        let productObj = {
                            key: product2.id,
                            productName: product2.brandName,
                            category: product2.categoryName,
                            supplier: product2.supplierName,
                            manufacturer: product2.manufacturerName,
                            quantity: 0,
                            costOfPrice: `Ksh ${product2.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
                            profit: `Ksh ${product2.profit.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
                            sellingPrice: `Ksh ${product2.sellingPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
                            // margin: `${product2.margin.toLocaleString(undefined,{minimumFractionDigits: 2})}%`,
                            action: product2
                        }

                        inventoryWithOutBal.push(productObj)
                    }
                }

                // inventoryWithBal.forEach(product => {
                //     finalAgentInventory.push(product)
                // })

                inventoryWithOutBal.forEach(product => {
                    finalAgentInventory.push(product)
                })
                this.tableData = inventoryWithOutBal
                this.tableLoading = false;
            } else {
                console.log('Error | ', response)
                this.showErrorAlert('Something went wrong, try again later.')
            }
        },
        async allDistributionCnters() {
            const response = await this.getAllDistributionCenters()
            if (response.status === 200) {
                this.distributionCenters = response.data.data;
                this.defaultValue = response.data.data[0].id
                this.distributionCenterId = response.data.data[0].id
                this.getPreProducts(this.distributionCenterId);
            } else {
                console.log('Error | ', response)
            }
        }
    },
    created() {
        // console.log(" items in created | ", this.getOrder);
        if (this.getOrder) {
            this.items = this.getOrder
            this.item = this.items
        }

        if (this.allDistributionCnters) {
            this.allDistributionCnters()
        }

        if (this.getClientProducts) {
            this.params.page = -1
            this.params.perPage = -1
            this.getClientProducts(this.params).then(response => {
                //    
                if (response.status === 200) {
                    this.availableProducts = response.data.data;
                } else {
                    console.log('Error | ', response)
                }
            }, error => {
                console.log('Error | ', error)
            })
        }


    }

}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.img_size {
    max-width: 40px;
    max-height: 40px;
}

.productTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.productTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.productTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.fulfillmentTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.fulfillmentTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.fulfillmentTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.fulfillmentTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>